import { optokineticNystagmusInstruction } from "@constants/instructionConstants";
import { virtualAssistanceOptokineticNystagmusConfig } from "@constants/virtualAssistanceConstants";
import {
  AvailablePreTestConfigurationOptions,
  EyeType,
  TestCategory,
  TestConfiguration,
  TestType,
  TestUIConfiguration,
} from "types/testTypes";
import {
  AVAILABLE_EYE_OPTIONS_BINOCULAR,
  AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS_ENGLISH_ONLY,
} from "../configurationHelperConstants";
import { CATEGORY_VERSION_MAP, TEST_TYPE_VERSION_MAP } from "../versionConstants";

export const availableOptokineticNystagmusTestConfigurationOptions: AvailablePreTestConfigurationOptions =
  {
    testTypes: {
      configurationFieldName: "testType",
      choices: [
        {
          validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.OptokineticNystagmus],
          value: TestType.OptokineticNystagmus,
        },
      ],
      isMandatory: true,
      validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.OptokineticNystagmus],
    },
    eyeConfigurationOptions: { ...AVAILABLE_EYE_OPTIONS_BINOCULAR },
    languageOptions: null,
    virtualAssistantOptions: { ...AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS_ENGLISH_ONLY },
    testSpeedOptions: null,
  };

export const optokineticNystagmusTestConfiguration: TestConfiguration = {
  name: TestCategory.OptokineticNystagmus,
  testType: TestType.OptokineticNystagmus,
  eyeConfiguration: {
    eyeType: EyeType.BothEye,
    isCalibrationNeeded: true,
    autoPauseForGaze: false,
    isTwoScreenFixationEnabled: false,
    isBackToBackEyeTest: false,
  },
  testSpeed: null,
  testLanguage: null,
  virtualAssistanceConfig: virtualAssistanceOptokineticNystagmusConfig,
  isPressToStartEnabled: true,
  extraData: null,
};

export const optokineticNystagmusUIConfiguration: TestUIConfiguration = {
  showProgressBar: true,
  instructions: optokineticNystagmusInstruction,
};
